import { useEffectOnce } from '@custom-react-hooks/use-effect-once';
import { RudderAnalytics } from '@rudderstack/analytics-js';
import { ENV_VARS } from '@/clients/util/env';

const enabled = ENV_VARS.PROD;
const writeKey = ENV_VARS.VITE_RUDDERSTACK_FRONTEND_WRITE_KEY;
const dataPlane = ENV_VARS.VITE_RUDDERSTACK_DATA_PLANE_URL;

let client: RudderAnalytics | undefined;

export const useRudderstack = (): typeof client => {
  useEffectOnce(() => {
    if (client || !enabled || !writeKey || !dataPlane) return;

    const instance = new RudderAnalytics();
    instance.load(writeKey, dataPlane);
    instance.ready(() => {});
    client = instance;
  });

  return client;
};
